"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _vuex = require("vuex");

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

var _utils = require("@/helpers/utils");

var apiClient = _interopRequireWildcard(require("@/api/client"));

var apiEnseigne = _interopRequireWildcard(require("@/api/enseigne"));

var apiSecteurGeo = _interopRequireWildcard(require("@/api/secteurgeo"));

var _exportModuleMixin = _interopRequireDefault(require("@/mixins/exportModuleMixin"));

var _exportListMixin = _interopRequireDefault(require("@/mixins/exportListMixin"));

var Excel = _interopRequireWildcard(require("exceljs"));

var _fileSaver = require("file-saver");

var _StickyTable = _interopRequireDefault(require("@/components/StickyTable.vue"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination.vue"));

var _ScrollBar = _interopRequireDefault(require("@/components/ScrollBar.vue"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'AffaireList',
  components: {
    Pagination: _Pagination.default,
    StickyTable: _StickyTable.default,
    ScrollBar: _ScrollBar.default
  },
  mixins: [_exportModuleMixin.default, _exportListMixin.default],
  props: {
    filters: {
      type: Object,
      required: false,
      default: null
    },
    manager: {
      type: String,
      required: false,
      default: null,
      validator: function validator(value) {
        // La valeur passée doit être l'une de ces chaines de caractères
        return ['commande', 'facture'].indexOf(value) !== -1;
      }
    }
  },
  data: function data() {
    return {
      currentPage: 1,
      pageSize: 100,
      CONST: CONST,
      clients: [],
      data: [],
      enseignes: [],
      secteursGeo: []
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)('affaire', ['getAffaireList']), {
    total: function total() {
      return this.data.length;
    }
  }),
  beforeMount: function beforeMount() {
    var _this = this;

    this.initMixinEvents();
    apiClient.getAll().then(function (results) {
      _this.clients = results;
    });
    apiEnseigne.getAll().then(function (results) {
      _this.enseignes = results;
    });
    apiSecteurGeo.getAll().then(function (results) {
      _this.secteursGeo = results;
    });
    this.loadData();
  },

  /*
  async mounted () {
    await this.loadData()
  },
  */
  watch: {
    'filters.idClient': function filtersIdClient(newVal, oldVal) {
      // Si on déselectionne le client
      if (newVal === null) {
        // On vide aussi la liste des enseignes liées
        this.filters.idEnseigne = null;
        this.filters.enseigne = null;
      } else {
        // On vide la sélection par n° d'affaire
        this.filters.numeroAffaire = null;
      } // Filtrer la liste des affaires


      this.loadData();
    },
    'filters.idEnseigne': function filtersIdEnseigne(newVal, oldVal) {
      // Filtrer la liste des affaires
      this.loadData();
    },
    'filters.numeroAffaire': function filtersNumeroAffaire(newVal, oldVal) {
      if (newVal !== null) {
        // On vide la liste des clients et des enseignes
        this.filters.idClient = null;
        this.filters.client = null;
        this.filters.idEnseigne = null;
        this.filters.enseigne = null;
      } // Filtrer la liste des affaires


      this.loadData();
    }
  },
  methods: {
    initMixinEvents: function initMixinEvents() {
      var exportEvent = '';
      var exportedEvent = '';

      switch (this.manager) {
        case 'commande':
          exportEvent = "VENTE_CREANCE_COMMANDE_EXPORT";
          exportedEvent = "VENTE_CREANCE_COMMANDE_EXPORTED";
          break;

        default:
          exportEvent = "VENTE_CREANCE_FACTURE_EXPORT";
          exportedEvent = "VENTE_CREANCE_FACTURE_EXPORTED";
      }

      this.mixinEvents = {
        export: exportEvent,
        exported: exportedEvent
      };
    },
    generateExcelFile: function () {
      var _generateExcelFile = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var workbook, title, worksheet, columnHeaderList, style, buffer, now, fileType, fileName, fileExtension, file, blob;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log('[AffaireList] generateExcelFile called!')
                // Classeur Excel
                workbook = new Excel.Workbook();
                title = this.getExportFileTitle(); // Propriétés du classeur

                workbook.creator = 'Groupe MARRAUD - EASY';
                workbook.lastModifiedBy = 'Groupe MARRAUD - EASY'; // workbook.lastPrinted = ''

                workbook.created = new Date(); // workbook.modified = ''

                workbook.company = 'Groupe MARRAUD';
                workbook.manager = '';
                workbook.title = "Export ".concat(title);
                workbook.subject = '';
                workbook.keywords = this.manager;
                workbook.category = '';
                workbook.description = "Cr\xE9ances / Ventes : ".concat(title); // workbook.language = ''
                // workbook.revision = ''
                // workbook.contentStatus = ''
                // Forcer les calculs au chargement du classeur

                workbook.calcProperties.fullCalcOnLoad = true; // Feuille de calcul avec en-tête et pied de page

                worksheet = workbook.addWorksheet(title, {
                  properties: {
                    defaultRowHeight: 15
                  },
                  headerFooter: {
                    firstHeader: 'Groupe MARRAUD - EASYs - &A',
                    firstFooter: '&L&D à &T&C&F&RPage &P sur &N'
                  },
                  views: [// Viger les volets sous la seconde ligne
                  {
                    state: 'frozen',
                    xSplit: 0,
                    ySplit: 1
                  }] // state: 'frozen',
                  // xSplit: 0,
                  // ySplit: 1,
                  // topLeftCell: 'A2'
                  // activeCell: 'A1',
                  // autoFilter: {
                  //   from: 'A1',
                  //   to: 'D1'
                  // }

                }); // Add column headers and define column keys and widths
                // Note: these column structures are a workbook-building convenience only,
                // apart from the column width, they will not be fully persisted.
                // Définition des colonnes d'en-tête

                columnHeaderList = this.getColumnHeaderList();
                worksheet.columns = columnHeaderList;
                worksheet.autoFilter = 'A1:F1'; // Données

                worksheet.addRows(this.getPreparedDataForExport()); // console.log('this.getPreparedDataForExport()', this.getPreparedDataForExport())

                /*
                // Totaux
                worksheet.addRow({
                  libr_createddate_date: 'Total',
                  libr_createddate_time: '',
                  libr_note: '',
                  libr_filename: '',
                  porte_matricule: '',
                  category: '',
                  libr_type: ''
                })
                */
                // Style et formatage génériques

                style = {
                  // en-tête
                  header: {
                    font: {
                      bold: true,
                      color: {
                        argb: 'FFFFFFFF'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FF000000'
                      }
                    },
                    alignment: {
                      vertical: 'center',
                      horizontal: 'bottom'
                    },
                    border: {
                      top: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      left: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      bottom: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      },
                      right: {
                        style: 'thin',
                        color: {
                          argb: 'FFFFFFFF'
                        }
                      }
                    }
                  },
                  // lignes paires
                  even: {
                    font: {
                      color: {
                        argb: 'FF000000'
                      }
                    },
                    fill: {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: {
                        argb: 'FFDDDDDD'
                      }
                    }
                  },
                  // lignes impaires
                  odd: {
                    font: {
                      color: {
                        argb: 'FF000000'
                      }
                    }
                  }
                }; // Mémorisation du numéro de la dernière ligne
                // const rowCount = worksheet.rowCount
                // Boucle sur les lignes de la feuille du classeur

                worksheet.eachRow(function (row, rowNumber) {
                  // Boucle sur les cellules de la ligne
                  row.eachCell({
                    includeEmpty: true
                  }, function (cell, colNumber) {
                    switch (rowNumber) {
                      // Ligne d'en-tête et de pied du tableur
                      case 1:
                        // case rowCount:
                        cell.style = _objectSpread({}, style.header);
                        break;
                      // Données

                      default:
                        var columnStyle = columnHeaderList[colNumber - 1].style || {};
                        var cellStyle = {}; // Lignes paires

                        if (rowNumber % 2 === 0) {
                          cellStyle = _objectSpread({}, style.even);
                        } else {
                          cellStyle = _objectSpread({}, style.odd);
                        }

                        cell.style = Object.assign({}, cell.style, columnStyle, cellStyle);
                        break;
                    }
                  });
                }); // Ecriture dans un nouveau buffer

                _context.next = 22;
                return workbook.xlsx.writeBuffer();

              case 22:
                buffer = _context.sent;
                // Paramètres du fichier généré dynamiquement
                now = (0, _utils.getDateNow)().format('YYYYMMDD-HHmmss'); // const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'

                fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                fileName = this.getExportFileName();
                fileExtension = 'xlsx';
                file = "".concat(now, "-").concat(fileName, ".").concat(fileExtension); // Création du Blob

                blob = new Blob([buffer], {
                  type: fileType
                }); // Servir le fichier via le navigateur client

                (0, _fileSaver.saveAs)(blob, file); // console.log('[AffaireList] generateExcelFile called')

              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function generateExcelFile() {
        return _generateExcelFile.apply(this, arguments);
      }

      return generateExcelFile;
    }(),
    getExportFileName: function getExportFileName() {
      var fileName = this.manager;

      if (this.filters.numeroAffaire) {
        fileName += "-".concat(this.filters.numeroAffaire);
      } else {
        if (this.filters.client) {
          fileName += "-".concat(this.filters.client.code);
        }

        if (this.filters.enseigne) {
          fileName += "-".concat(this.filters.enseigne.code);
        }
      }

      return fileName;
    },
    getExportFileTitle: function getExportFileTitle() {
      var title = this.manager;

      if (this.filters.numeroAffaire) {
        title += " - Affaire ".concat(this.filters.numeroAffaire);
      } else {
        if (this.filters.client) {
          title += "- ".concat(this.filters.client.code);
        }

        if (this.filters.enseigne) {
          title += "-".concat(this.filters.enseigne.code);
        }
      }

      return title;
    },
    getColumnHeaderList: function getColumnHeaderList() {
      var defaultStyles = {
        monetaire: {
          numFmt: '# ##0.00 "€";[Red]-# ##0.00 "€"',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        },
        pourcentage: {
          numFmt: '##0.00%',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        },
        date: {
          numFmt: 'dd/mm/yyyy',
          alignment: {
            vertical: 'top',
            horizontal: 'center'
          }
        },
        nombre: {
          numFmt: '0',
          alignment: {
            vertical: 'top',
            horizontal: 'right'
          }
        }
      }; // Colonnes d'en-tête

      var columnHeaderList = [// Affaire
      {
        header: 'N° Affaire',
        key: 'num_affaire',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        }
      }, {
        header: 'Nom affaire',
        key: 'nom',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        }
      }, {
        header: 'Client',
        key: 'client',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        }
      }, {
        header: 'Enseigne',
        key: 'enseigne',
        width: 30,
        style: {
          alignment: {
            vertical: 'top'
          }
        }
      }, {
        header: 'Secteur géo',
        key: 'secteurGeo',
        width: 10 + 4,
        style: {
          alignment: {
            vertical: 'top',
            horizontal: 'center'
          }
        }
      }];

      if (this.manager === 'commande') {
        columnHeaderList.push({
          header: 'Montant commandes',
          key: 'total_montant_commandes',
          width: 25,
          style: defaultStyles.monetaire
        });
      }

      var columnName = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      columnHeaderList.forEach(function (x, index) {
        x.c = columnName[index];
        x.position = index + 1;
      });
      return columnHeaderList;
    },
    getPreparedDataForExport: function getPreparedDataForExport() {
      var _this2 = this;

      // On utilise les données pré-filtrées par le dataTable
      var data = this.$refs.dataTable.tableData;
      var result = data.map(function (item) {
        return _objectSpread({}, item, {
          client: _this2.client(item.id_client),
          enseigne: _this2.enseigne(item.id_enseigne),
          secteurGeo: _this2.secteurGeo(item.id_secteur_geo)
        });
      });
      /*
      data.forEach(row => {
        // Dates
        // Attention : pour les transpositions de dates EN -> FR
        // on assigne la valeur transposée de row.{object}.date
        // à la propriété racine row.{object_prop_with_date}
        // sinon on transposerais à chaque fois la même date
        // et cela donnerait des dates invalides
        // row.commande_date = (row.commande.date ? toDate(row.commande.date) : null)
        // row.facture_date_facture = (row.facture.date_facture ? toDate(row.facture.date_facture) : null)
        // row.facture_date_echeance = (row.facture.date_echeance ? toDate(row.facture.date_echeance) : null)
        // row.reglement_date = (row.reglement.date ? toDate(row.reglement.date) : null)
         // Mode de règlement
        // row.reglement_mode = (row.reglement.mode ? getLabelModeReglement(row.reglement.mode) : null)
      })
      */

      return result;
    },
    loadData: function loadData() {
      var _this3 = this;

      var data = this.getAffaireList;

      if (this.filters.idClient) {
        if (this.filters.idEnseigne) {
          data = data.filter(function (item) {
            return item.id_enseigne === _this3.filters.idEnseigne;
          });
        } else {
          data = data.filter(function (item) {
            return item.id_client === _this3.filters.idClient;
          });
        }
      } else if (this.filters.numeroAffaire) {
        data = data.filter(function (item) {
          var numAffaire = item.num_affaire.toLowerCase();
          return numAffaire.indexOf(_this3.filters.numeroAffaire.toLowerCase()) > -1;
        });
      }

      this.data = data;
    },
    client: function client(idClient) {
      var client = this.clients.find(function (x) {
        return x.id === idClient;
      });
      return client ? client.libelle : '';
    },
    enseigne: function enseigne(idEnseigne) {
      var enseigne = this.enseignes.find(function (x) {
        return x.id === idEnseigne;
      });
      return enseigne ? enseigne.libelle : '';
    },
    secteurGeo: function secteurGeo(idSecteurGeo) {
      var secteurGeo = this.secteursGeo.find(function (x) {
        return x.id === idSecteurGeo;
      });
      return secteurGeo ? secteurGeo.libelle : '';
    },
    handleCommand: function handleCommand(_ref) {
      var action = _ref.action,
          index = _ref.index,
          row = _ref.row;

      switch (action) {
        case 'facture':
          this.$emit('select-affaire', {
            index: index,
            row: row,
            nextTickEventName: 'FACTURE_NEW'
          });
          break;

        case 'reglements':
          this.$emit('select-affaire', {
            index: index,
            row: row
          });
          break;
      }
    },
    handleManageLink: function handleManageLink(index, row) {
      this.$emit('select-affaire', {
        index: index,
        row: row
      });
    }
  }
};
exports.default = _default;